import Vue from 'vue';
import VueRouter from 'vue-router';
import core from './routes/core';
import user from './routes/user';
import dashboard from './routes/dashboard';
import umkm from './routes/umkm';
import transaksi from './routes/transaksi';
import store from '@/store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
      component: () =>
        import(/* webpackChunkName: "routes" */ `@/views/Login.vue`),
      // redirect if already signed in
      beforeEnter: (to, from, next) => {
        if (store.getters['user/authorized']) {
          next('/dashboard');
        } else {
          next();
        }
      },
    },
    ...dashboard,
    ...core,
    ...user,
    ...transaksi,
    ...umkm,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['user/authorized']) {
      next();
      return;
    }
    next('/');
  } else {
    next();
  }
});
router.beforeResolve((to, from, next) => {
  if (to.path) {
    store.commit('app/SET_SPINNER', true);
  }
  next();
});

router.afterEach(() => {
  store.commit('app/SET_SPINNER', false);
});

export default router;
